/* global fetch, rp$ */
import { get } from 'lodash';
import { clearLocalStorage, getSessionUrls } from './paypal-utils';
import { ORIGINS } from './paypal-constants';

const approveOrder = (data, actions) => {
	const sessionUrls = getSessionUrls();
	const baseUrl = get(sessionUrls, 'returnUrl');
	const url = `${baseUrl}/${ORIGINS.paypal.checkout}?token=${data.orderID}`;

	rp$('body').overlaySpinner();

	return fetch(url)
		.then(function (response) {
			//once the order is approved remove paypal local storage keys
			clearLocalStorage();

			if(response.redirected && response.url) {
				actions.redirect(response.url);
			}
		});
};

module.exports = approveOrder;
